<template>
  <div class="ffk-whats-new-sidebar">
    <div>
      <b-sidebar
        id="whats-new-sidebar-right"
        right
        bg-variant="white"
        no-header
        no-header-close
        v-model="_visible"
        :width="barWidth"
        backdrop
      >
        <div class="whats-new-sidebar-wrapper">
          <div class="whats-new-sidebar-container--top" ref="whatsNewSidebarSubtitle">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <h5>{{ title }}</h5>

              <span @click="toggleSidebar" class="pb-2 ffk-cursor-pointer">
                <font-awesome-icon :icon="['fas', 'times']" size="lg" />
              </span>
            </div>

            <div v-if="subtitleAvailable" class="content-subtitle">
              {{ subtitle }}
            </div>
          </div>
          <div class="whats-new-sidebar-container ffk-custom-scroll">
            <div v-if="$slots['header']">
              <slot name="header"> Header slot </slot>
            </div>
            <div v-if="$slots['content']">
              <slot name="content"> Content slot </slot>
            </div>
            <div v-if="$slots['bottom']">
              <slot name="bottom"> Bottom slot </slot>
            </div>
          </div>
        </div>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    barWidth: {
      type: String,
      default: '600px',
    },
    visible: Boolean,
    title: String,
    subtitleAvailable: Boolean,
    subtitle: String,
  },
  data() {
    return {}
  },
  computed: {
    _visible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
  },
  methods: {
    toggleSidebar() {
      // toggle visibility
      this._visible = !this._visible
    },
  },
}
</script>

<style lang="scss">
.ffk-whats-new-sidebar {
  #whats-new-sidebar-right {
    // flex trick for overflow-y
    .whats-new-sidebar-wrapper {
      height: 100%;
      margin: 0;
      display: flex;
      flex-direction: column;
    }

    .whats-new-sidebar-container--top {
      padding: 28px 40px 28px 40px;
      border-bottom: 1px solid #0000001a;
      // flex trick for overflow-y
      flex: 0 0 auto;

      .content-subtitle {
        font-size: 0.875rem;
        line-height: 1.2;
      }
    }
    .whats-new-sidebar-container {
      padding: 0px 40px 28px 40px;
      // flex trick for overflow-y
      flex: 1 1 auto;
      position: relative;
      overflow-y: auto;
    }
  }
}
</style>
